import { render, staticRenderFns } from "./Increase.vue?vue&type=template&id=6c4f04c6&"
import script from "./Increase.vue?vue&type=script&lang=js&"
export * from "./Increase.vue?vue&type=script&lang=js&"
import style0 from "./Increase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports